/** The embed URL: youtube-nocookie, autoplaying because the visitor has just pressed play. */
export function demoVideoEmbedUrl(youtubeId: string): string {
  return `https://www.youtube-nocookie.com/embed/${encodeURIComponent(youtubeId)}?autoplay=1&rel=0&modestbranding=1`;
}
